import { useMemo } from 'react'
import { menuItems } from '../components/SideMenu/data'
import { withoutPrefix } from '../utils/prefix'

const usePrimaryMenuItems = location => {
	const currentPrimaryMenuItem = useMemo(() => {
		const pathname = withoutPrefix(location.pathname)

		const topLevelPath = pathname.split('/').slice(0, 2).join('/')
		return menuItems.find(item => item.url?.includes(topLevelPath))
	}, [location.pathname])

	return { primaryMenuItems: menuItems, currentPrimaryMenuItem }
}

export default usePrimaryMenuItems
